import { createSlice } from '@reduxjs/toolkit';
import { facebook, apiResponse } from 'appConstants';
import {
  saveFacebookPages,
  facebookLogin,
  saveFacebookName,
  facebookSequences,
  resetFacebookPages,
  addFacebook,
  setSelectedPage,
  updateFacebook,
  setDeletePage,
  removeFacebook,
  refreshFacebook,
  resetRefreshFacebookStatus,
} from 'redux/actions/facebook';
const initialState = {
  facebookPageData: null,
  isFacebookLogin: false,
  facebookName: '',
  facebookId: '',
  facebookAriSequences: [],
  selectedPage: null,
  facebookARIMappingStatus: '',
  isAddFacebookPending: false,
  deletePage: null,
  isRemoveFacebookPending: false,
  removeFacebookStatus: '',
  isRefreshFacebookStatus: false,
};

const facebookSlice = createSlice({
  name: 'facebook',
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder.addCase(saveFacebookPages, (state, action) => {
      state.facebookPageData = action.payload.data;
    });

    builder.addCase(resetFacebookPages, (state) => {
      state.facebookPageData = initialState.facebookPageData;
      state.selectedPage = initialState.selectedPage;
      state.isFacebookLogin = initialState.isFacebookLogin;
      state.isAddFacebookPending = initialState.isAddFacebookPending;
      state.facebookARIMappingStatus = initialState.facebookARIMappingStatus;
      state.deletePage = initialState.deletePage;
      state.isRemoveFacebookPending = initialState.isRemoveFacebookPending;
      state.removeFacebookStatus = initialState.removeFacebookStatus;
      state.isRefreshFacebookStatus = initialState.isRefreshFacebookStatus;
    });

    builder.addCase(facebookLogin, (state, action) => {
      if (action.payload.status === facebook.CONNECTED) {
        state.isFacebookLogin = true;
      }
    });

    builder.addCase(saveFacebookName, (state, action) => {
      state.facebookName = action.payload.name;
      state.facebookId = action.payload.id;
    });

    builder.addCase(facebookSequences.fulfilled, (state, action) => {
      state.facebookAriSequences = action.payload.sequences;
    });

    builder.addCase(addFacebook.pending, (state) => {
      state.isAddFacebookPending = true;
    });

    builder.addCase(addFacebook.fulfilled, (state) => {
      state.facebookARIMappingStatus = apiResponse.SUCCESS;
      state.isAddFacebookPending = false;
    });

    builder.addCase(addFacebook.rejected, (state) => {
      state.facebookARIMappingStatus = apiResponse.ERROR;
      state.isAddFacebookPending = false;
    });

    builder.addCase(setSelectedPage, (state, action) => {
      state.selectedPage = action.payload;
    });

    builder.addCase(updateFacebook.fulfilled, (state) => {
      state.facebookARIMappingStatus = apiResponse.SUCCESS;
      state.isAddFacebookPending = false;
    });

    builder.addCase(updateFacebook.rejected, (state) => {
      state.facebookARIMappingStatus = apiResponse.ERROR;
      state.isAddFacebookPending = false;
    });

    builder.addCase(updateFacebook.pending, (state) => {
      state.isAddFacebookPending = true;
    });

    builder.addCase(setDeletePage, (state, action) => {
      state.deletePage = action.payload;
    });

    builder.addCase(removeFacebook.fulfilled, (state) => {
      state.isRemoveFacebookPending = false;
      state.removeFacebookStatus = apiResponse.SUCCESS;
    });

    builder.addCase(removeFacebook.rejected, (state) => {
      state.isRemoveFacebookPending = false;
      state.removeFacebookStatus = apiResponse.ERROR;
    });

    builder.addCase(removeFacebook.pending, (state) => {
      state.isRemoveFacebookPending = true;
    });

    builder.addCase(refreshFacebook.fulfilled, (state) => {
      state.isRefreshFacebookStatus = true;
    });

    builder.addCase(resetRefreshFacebookStatus, (state) => {
      state.isRefreshFacebookStatus = false;
    });
  },
});

export default facebookSlice;
